import React from 'react';
import PropTypes from 'prop-types';
import {FormattedDate} from "react-intl";

import {getDistinctRetailers} from "views/oms/OrderList/utils/getDistinctRetailers";

import {blue500, greyishBlue500} from "assets/jss/main";

OrderInfos.propTypes = {
    externalId: PropTypes.string.isRequired,
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]).isRequired,
    lineItems: PropTypes.array,
};

function OrderInfos({externalId, date, lineItems = []}) {
    const retailerCount = getDistinctRetailers(lineItems).length;

    return (
        <div>
            <span style={{color: blue500, fontWeight: 600}}>
                #{externalId}
                {retailerCount > 1 && ` (${retailerCount})`}
            </span>
            <div style={{color: greyishBlue500, fontWeight: 400, display: 'flex', flexDirection: 'column'}}>
                <div><FormattedDate value={date} day='2-digit' month='2-digit' year='numeric'/></div>
                <div><FormattedDate value={date} hour='2-digit' minute='2-digit' hour12={false} /></div>
            </div>
        </div>
    );
}

export default OrderInfos;
